import * as Yup from 'yup';

import {
  DocumentUnderstandingAgentPricesStrategy,
  DocumentUnderstandingAgentRelationshipOverride,
} from 'services/repositories/documentUnderstandingAgent/documentUnderstandingAgent';
import { DropdownOptionType } from 'components/Form/Dropdown/types';

// Mirrors the backend grammar (UpdateDocumentUnderstandingAgentSettingsRequest): either `*` as the whole local
// part (`*@domain.tld`) or a normal local part that may itself contain `*` as a literal character
// (e.g. `no-reply*@acme.com`), followed by a `domain.tld`. Case-insensitive.
export const SENDER_PATTERN_REGEX = /^(\*@[^@\s]+\.[^@\s]+|[^@\s]+@[^@\s]+\.[^@\s]+)$/i;

export const isValidSenderPattern = (value: string) => SENDER_PATTERN_REGEX.test(value);
export const isValidEmail = (value: string) => Yup.string().email().isValidSync(value);

export const PRICE_STRATEGY_LABEL_KEYS: Record<DocumentUnderstandingAgentPricesStrategy, string> = {
  disabled: 'settings:documentUnderstandingAgent.global.priceStrategy.strategy.disabled',
  master_data: 'settings:documentUnderstandingAgent.global.priceStrategy.strategy.masterData',
  document: 'settings:documentUnderstandingAgent.global.priceStrategy.strategy.document',
  document_and_master_data: 'settings:documentUnderstandingAgent.global.priceStrategy.strategy.documentAndMasterData',
};

export const PRICE_STRATEGY_OPTIONS: Array<DropdownOptionType<DocumentUnderstandingAgentPricesStrategy>> = (
  Object.keys(PRICE_STRATEGY_LABEL_KEYS) as Array<DocumentUnderstandingAgentPricesStrategy>
).map((strategy) => ({ value: strategy, label: PRICE_STRATEGY_LABEL_KEYS[strategy] }));

export const hasConnectionOverrides = ({ configuration }: DocumentUnderstandingAgentRelationshipOverride): boolean =>
  configuration.prices_extraction_strategy !== null ||
  configuration.preferred_units_of_measure.length > 0 ||
  Boolean(configuration.custom_instructions) ||
  configuration.custom_line_item_quantity_types.length > 0;

export type EditableDocumentUnderstandingAgentSections = {
  extraction: {
    prices_strategy: DocumentUnderstandingAgentPricesStrategy;
  };
  sender_filter: {
    whitelist: Array<string>;
    blacklist: Array<string>;
  };
  replies_filter: {
    emails: Array<string>;
    notifications_enabled: boolean;
  };
};

export const DEFAULT_DOCUMENT_UNDERSTANDING_AGENT_FORM_VALUES: EditableDocumentUnderstandingAgentSections = {
  extraction: {
    prices_strategy: 'disabled',
  },
  sender_filter: {
    whitelist: [],
    blacklist: [],
  },
  replies_filter: {
    emails: [],
    notifications_enabled: true,
  },
};
